import { render, staticRenderFns } from "./QuestionPostiveNegative.vue?vue&type=template&id=20a94cea&scoped=true"
import script from "./QuestionPostiveNegative.vue?vue&type=script&lang=js"
export * from "./QuestionPostiveNegative.vue?vue&type=script&lang=js"
import style0 from "./QuestionPostiveNegative.vue?vue&type=style&index=0&id=20a94cea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a94cea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VBtn,VList,VListItem,VListItemAction,VListItemContent,VListItemTitle,VRadio,VRadioGroup})
